<template>
  <main id="js-page-content" role="main" class="page-content">
    <div class="row">
      <div class="subheader col-6">
        <h1 class="subheader-title">売上予想表（単独）</h1>
      </div>
      <!-- Right content on content header A nice area to add graphs or buttons -->
      <div class="subheader-block ml-auto demo">
        <button
          type="button"
          :disabled="btnDisable"
          class="btn btn-primary waves-effect waves-themed"
        >
          <span class="fal fa-download mr-1"></span>出力
        </button>
      </div>
    </div>
    <!-- Your main content goes below here: -->
    <div class="row">
      <div class="col-xl-12">
        <div id="panel-1" class="panel">
          <div class="panel-hdr">
            <h2>対象</h2>
            <div class="panel-toolbar">
              <button
                class="btn btn-panel"
                data-action="panel-collapse"
                data-toggle="tooltip"
                data-offset="0,10"
                data-original-title="Collapse"
              ></button>
              <button
                class="btn btn-panel"
                data-action="panel-fullscreen"
                data-toggle="tooltip"
                data-offset="0,10"
                data-original-title="Fullscreen"
              ></button>
            </div>
          </div>
          <div class="panel-container show" id="panel-target">
            <div class="loader">
              <i class="fal fa-spinner-third fa-spin-4x fs-xxl"></i>
            </div>
            <div class="panel-content contents">
              <div class="row">
                <div class="col-md-1 contTitle">出力年度</div>
                <div class="col-md-4 contCnt">
                  <vSelect :options="optionsOp"></vSelect>
                </div>
                <div class="col-md-1">期</div>
              </div>
              <div class="row">
                <div class="col-md-1 contTitle">集計期間</div>
                <div class="col-md-4 contCnt">
                  <vSelect :options="optionsOp2"></vSelect>
                </div>
                <div class="col-md-1">ヶ月</div>
              </div>
              <div class="row">
                <div class="col-md-1 contTitle"></div>
                <div class="col-md-auto contCnt demo">
                  <button
                    type="button"
                    :disabled="btnDisable"
                    class="btn btn-primary waves-effect waves-themed"
                  >
                    <span class="fal fa-download mr-1"></span>当期単月
                  </button>
                  <button
                    type="button"
                    :disabled="btnDisable"
                    class="btn btn-primary waves-effect waves-themed"
                  >
                    <span class="fal fa-download mr-1"></span>単月前年比
                  </button>
                  <button
                    type="button"
                    :disabled="btnDisable"
                    class="btn btn-primary waves-effect waves-themed"
                  >
                    <span class="fal fa-download mr-1"></span>累計前年比
                  </button>
                  <button
                    type="button"
                    :disabled="btnDisable"
                    class="btn btn-primary waves-effect waves-themed"
                  >
                    <span class="fal fa-download mr-1"></span>累計先月比
                  </button>
                  <button
                    type="button"
                    :disabled="btnDisable"
                    class="btn btn-primary waves-effect waves-themed"
                  >
                    <span class="fal fa-download mr-1"></span>当期累計
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- エラー確認モーダル -->
    <!-- エラー確認モーダル -->
  </main>
</template>

<script lang="ts">
import { Options, Vue } from "vue-class-component";
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";
import Mo_modal_alert from "@/components/molecules/Mo_modal_alert.vue";

@Options({
  components: {
    vSelect,
    Mo_modal_alert,
  },
})
export default class SalesForecastNonConsolidated extends Vue {
  //----------------------
  //DOM連携用プロパティ
  //----------------------
  btnDisable = false;

  optionsOp = [
    { label: "59" },
    { label: "60" },
    { label: "61" },
    { label: "62" },
  ];
  optionsOp2 = [
    { label: "1" },
    { label: "2" },
    { label: "3" },
    { label: "4" },
    { label: "5" },
    { label: "6" },
    { label: "7" },
    { label: "8" },
    { label: "9" },
    { label: "10" },
    { label: "11" },
    { label: "12" },
  ];
}
</script>
